/// <amd-module name="SuiteCommerce.FeaturedCategory.Item.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Item.View", ["require", "exports", "Backbone", "SuiteCommerce.FeaturedCategory.Instrumentation", "SuiteCommerce.FeaturedCategory.Common.Utils", "SuiteCommerce.FeaturedCategory.Item.Configuration", "sc_featuredcategory_item.tpl"], function (require, exports, Backbone_1, Instrumentation_1, Utils_1, Item_Configuration_1, featuredCategoryItemTpl) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemView = /** @class */ (function (_super) {
        __extends(ItemView, _super);
        function ItemView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = featuredCategoryItemTpl;
            _this.colsPerRow = options.colsPerRow;
            _this.colsPerRowPhone = options.colsPerRowPhone;
            _this.showItemPrice = options.showItemPrice;
            _this.showItemName = options.showItemName;
            return _this;
        }
        ItemView.prototype.logQuickAddButton = function () {
            var quickAddButtonUsageLog = Instrumentation_1.default.getLog('quickAddButtonUsageLog');
            quickAddButtonUsageLog.setParameters({
                activity: 'Quick add button pressed',
            });
            quickAddButtonUsageLog.submit();
        };
        ItemView.prototype.getImageData = function () {
            var unavailableImgLink = 'img/no_image_available.jpeg';
            var itemImagesDetail = this.model.itemImagesDetail || {};
            itemImagesDetail = itemImagesDetail.media || itemImagesDetail;
            var images = Utils_1.Utils.imageFlatten(itemImagesDetail);
            return images.length ? images[0] : {
                url: Utils_1.Utils.getThemeAbsoluteUrlOfNonManagedResources(unavailableImgLink, Item_Configuration_1.ItemConfiguration.imageNotAvailable),
                altimagetext: Utils_1.Utils.translate('Image not available'),
            };
        };
        ItemView.prototype.getItemPrice = function () {
            if (Utils_1.Utils.hidePrices()) {
                return '';
            }
            var matrixDetail = this.model.matrixChildItemsDetail;
            if (matrixDetail && matrixDetail.length > 0) {
                var min = 0;
                var max = 0;
                var minFormatted = '';
                var maxFormatted = '';
                for (var i = 0; i < matrixDetail.length; i += 1) {
                    var priceDetail = matrixDetail[i].onlinecustomerprice_detail;
                    var price = priceDetail && (priceDetail.onlinecustomerprice || priceDetail.pricelevel1) || 0;
                    var priceFormatted = priceDetail && (priceDetail.onlinecustomerprice_formatted || priceDetail.pricelevel1_formatted) || '';
                    if (price > 0 && (price < min || min === 0)) {
                        min = price;
                        minFormatted = priceFormatted;
                    }
                    if (price > max) {
                        max = price;
                        maxFormatted = priceFormatted;
                    }
                }
                if (min > 0 && max > 0 && min !== max) {
                    return minFormatted + " " + Utils_1.Utils.translate('to') + " " + maxFormatted;
                }
            }
            var priceData = this.model.onlineCustomerPriceDetail;
            return priceData && priceData.onlinecustomerprice_formatted || this.model.priceLevel1Formatted || '';
        };
        ItemView.prototype.getContext = function () {
            var displayName = this.model.displayName;
            var imgData = this.getImageData();
            var itemPrice = this.getItemPrice();
            var itemLink = this.model.urlComponent ?
                "/" + this.model.urlComponent : "/product/" + this.model.internalId;
            return {
                displayName: displayName,
                itemPrice: itemPrice,
                itemLink: itemLink,
                renderItem: !!(displayName && imgData && imgData.url),
                imageUrl: imgData ? imgData.url : '',
                imageAlt: imgData ? imgData.altimagetext : '',
                colsPerRow: this.colsPerRow,
                colsPerRowPhone: this.colsPerRowPhone,
                showItemName: this.showItemName,
                showItemPrice: this.showItemPrice,
            };
        };
        return ItemView;
    }(Backbone_1.View));
    exports.ItemView = ItemView;
});
